import { gql } from "@apollo/client";
import type { IBuySellItem } from "types/BuySell.type";

export interface IGetBuySellItemsPaginatedInput {
  search?: string;
  category?: string[];
  condition?: string[];
  status?: string[];
  mine?: boolean;
  limit?: number;
  offset?: number;
}

export interface IGetBuySellItemsPaginatedResponse {
  items: IBuySellItem[];
  total: number;
  totalPages: number;
}

const BUY_SELL_ITEM_FIELDS = gql`
  fragment BuySellItemFields on BuySellItem {
    id
    title
    description
    price
    currency
    category
    condition
    status
    images
    createdAt
    updatedAt
    soldAt
    sellerId
    canManage
    seller {
      id
      name
      lastname
      profileImage
      email
    }
  }
`;

const GET_BUY_SELL_ITEMS_PAGINATED = gql`
  ${BUY_SELL_ITEM_FIELDS}
  query GetBuySellItemsPaginated($getBuySellItemsPaginatedInput: GetBuySellItemsPaginatedInput!) {
    getBuySellItemsPaginated(getBuySellItemsPaginatedInput: $getBuySellItemsPaginatedInput) {
      items {
        ...BuySellItemFields
      }
      total
      totalPages
    }
  }
`;

const GET_BUY_SELL_ITEM = gql`
  ${BUY_SELL_ITEM_FIELDS}
  query GetBuySellItem($id: String!) {
    getBuySellItem(id: $id) {
      ...BuySellItemFields
    }
  }
`;

export default {
  GET_BUY_SELL_ITEMS_PAGINATED,
  GET_BUY_SELL_ITEM,
};
